import {useMutation} from 'react-query';

type S3UploadMutationInput = {
    url: string;
    file: File;
};

// eslint-disable-next-line import/prefer-default-export
export function useS3UploadMutation() {
    return useMutation<void, Error, S3UploadMutationInput>(async ({url, file}) => {
        const resp = await fetch(url, {
            method: 'PUT',
            body: file,
        });

        if (resp.ok) return;

        throw new Error(`Document upload failed due to: {${resp.status}, ${resp.text() || 'Unknown'}}`);
    });
}
